var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lazy-image-container",style:({
    height: _vm.heightStyle,
    width: _vm.widthStyle
  })},[(!_vm.loaded)?_c('v-skeleton-loader',{staticClass:"rounded",style:({ height: _vm.heightStyle, width: '100%', display: 'block' }),attrs:{"type":"image"}}):_vm._e(),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],staticClass:"lazy-image",style:({
      width: _vm.widthStyle,
      height: _vm.heightStyle,
      objectFit: 'contain',
      display: 'block'
    }),attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":_vm.onLoad}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }